'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.run(function ($rootScope, $applications) {
  $rootScope.appPath = $applications.getCurrentAppPath();
});
ngModule.factory("$applications", function ($window, $APP_NAME, $session) {
  var applicationMap = {
    DETTE: {
      id: "DETTE",
      path: "/tael",
      publicApp: false,
      isAllowed: function isAllowed(habilitations) {
        return _.includes(habilitations, "MODULE_DETTE");
      }
    },
    DETTE_GARANTIE: {
      id: "DETTE_GARANTIE",
      path: "/dette-garantie",
      publicApp: false,
      isAllowed: function isAllowed(habilitations) {
        return _.includes(habilitations, "MODULE_DETTE_GARANTIE");
      }
    },
    PLACEMENT: {
      id: "PLACEMENT",
      path: "/placement",
      publicApp: false,
      isAllowed: function isAllowed(habilitations) {
        return _.includes(habilitations, "MODULE_PLACEMENT");
      }
    },
    OBSERVATOIRE_FINANCIER: {
      id: "OBSERVATOIRE_FINANCIER",
      path: "/of",
      publicApp: false,
      isAllowed: function isAllowed(habilitations) {
        return _.includes(habilitations, "MODULE_OBSERVATOIRE_FINANCIER");
      }
    },
    INTRA: {
      id: "INTRA",
      path: "/intra",
      publicApp: false,
      isAllowed: function isAllowed(habilitations) {
        return _.includes(habilitations, "INTRA_TAELYS");
      }
    },
    OBSERVATOIRE: {
      id: "OBSERVATOIRE",
      path: "/observatoire",
      publicApp: true,
      isAllowed: function isAllowed(habilitations) {
        return true;
      }
    },
    PRET: {
      id: "PRET",
      path: "/pret",
      publicApp: false,
      isAllowed: function isAllowed(habilitations) {
        return _.includes(habilitations, "MODULE_PRET");
      }
    },
    PRET_INTRA: {
      id: "PRET_INTRA",
      path: "/pret-intra",
      publicApp: false,
      isAllowed: function isAllowed(habilitations) {
        return _.includes(habilitations, "MODULE_PRET_INTRA");
      }
    },
    CREDIT_BAIL: {
      id: "CREDIT_BAIL",
      path: "/credit-bail",
      publicApp: false,
      isAllowed: function isAllowed(habilitations) {
        return _.includes(habilitations, "MODULE_CREDIT_BAIL");
      }
    },
    AIDE_SUBVENTION: {
      id: "AIDE_SUBVENTION",
      path: "/aide-subvention",
      publicApp: false,
      isAllowed: function isAllowed(habilitations) {
        return _.includes(habilitations, "MODULE_AIDE_SUBVENTION");
      }
    }
  };
  var $applications = {
    getApplicationNames: function getApplicationNames() {
      return _.keys(applicationMap);
    },
    getCurrentApp: function getCurrentApp() {
      return $applications.getApp($APP_NAME);
    },
    getCurrentAppId: function getCurrentAppId() {
      return $applications.getCurrentApp().id;
    },
    getCurrentAppPath: function getCurrentAppPath() {
      return $applications.getCurrentApp().path;
    },
    getApp: function getApp(appId) {
      return _.find(applicationMap, {
        id: appId
      });
    },
    getApplicationUrl: function getApplicationUrl(appId, path, compteId) {
      var appPath = $applications.getApp(appId).path;
      var url = appPath + (path || "/");
      if (compteId) {
        if (url.indexOf("?") !== -1) {
          url += "&toCompte=" + compteId;
        } else {
          url += "?toCompte=" + compteId;
        }
      }
      return url;
    },
    switchToApp: function switchToApp(appId) {
      // TODO : isAllowed check ?
      var app = $applications.getApp(appId);
      $window.location.href = app.path;
    },
    getAllowedApplications: function getAllowedApplications() {
      var apps = [];
      var habilitations = $session.getHabilitations();
      _.each(applicationMap, function (application) {
        if (application.isAllowed(habilitations)) {
          apps.push(application);
        }
      });
      return apps;
    },
    isDetteApplication: function isDetteApplication() {
      return $applications.getCurrentAppId() === "DETTE";
    },
    isDetteGarantieApplication: function isDetteGarantieApplication() {
      return $applications.getCurrentAppId() === "DETTE_GARANTIE";
    },
    isPretApplication: function isPretApplication() {
      return $applications.getCurrentAppId() === "PRET";
    },
    isPlacementApplication: function isPlacementApplication() {
      return $applications.getCurrentAppId() === "PLACEMENT";
    },
    isPretIntraApplication: function isPretIntraApplication() {
      return $applications.getCurrentAppId() === "PRET_INTRA";
    },
    isObservatoireFinancierApplication: function isObservatoireFinancierApplication() {
      return $applications.getCurrentAppId() === "OBSERVATOIRE_FINANCIER";
    },
    isCreditBailApplication: function isCreditBailApplication() {
      return $applications.getCurrentAppId() === "CREDIT_BAIL";
    },
    isAideSubventionApplication: function isAideSubventionApplication() {
      return $applications.getCurrentAppId() === "AIDE_SUBVENTION";
    }
  };
  return $applications;
});
ngModule.directive("ifDette", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if ($applications.isDetteApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
});
ngModule.directive("ifPret", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if ($applications.isPretApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
});
ngModule.directive("ifNotPret", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if (!$applications.isPretApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
});
ngModule.directive("ifPlacement", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if ($applications.isPlacementApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
});
ngModule.directive("ifNotPlacement", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if (!$applications.isPlacementApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
});
ngModule.directive("ifPretIntra", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if ($applications.isPretIntraApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
});
ngModule.directive("ifNotPretIntra", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if (!$applications.isPretIntraApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
});
ngModule.directive("ifCreditBail", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if ($applications.isCreditBailApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
});
ngModule.directive("ifNotCreditBail", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if (!$applications.isCreditBailApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
});
ngModule.directive("ifDetteGarantie", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if ($applications.isDetteGarantieApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
});
ngModule.directive("ifNotObservatoireFinancier", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if (!$applications.isObservatoireFinancierApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
});
ngModule.directive("ifObservatoireFinancier", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if ($applications.isObservatoireFinancierApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
});
ngModule.directive("ifAideSubvention", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if ($applications.isAideSubventionApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
});
ngModule.directive("ifNotAideSubvention", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if (!$applications.isAideSubventionApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
});
ngModule.directive("ifApplication", function ($applications, $animate) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      var applicationNames = $attrs.ifApplication;
      var found = false;
      var applications = applicationNames.split('||');
      for (var i = 0; i < applications.length && !found; i++) {
        var inclusif = true;
        var applicationName = applications[i].trim();
        if (applicationName) {
          if (applicationName.substr(0, 1) === '!') {
            inclusif = false;
            applicationName = applicationName.substr(1);
          }
          if (applicationName && $applications.getCurrentAppId() === applicationName && inclusif || $applications.getCurrentAppId() !== applicationName && !inclusif) {
            found = true;
            $transclude($scope, function (clone) {
              $animate.enter(clone, $element.parent(), $element);
            });
          }
        }
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/security/$applications.js
// module id = 2720
// module chunks = 13